import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    togglerWithWarningObject,
    warningTextsObject
} from '../../constants-types/constants';
@Component({
    selector: 'toggler-with-warning',
    template: `
        <div (clickOutside)="focusLost()">
            <div
                class="piToggle"
                [ngClass]="{
                    'piToggle-on': togglerWithWarningObject.isTogglerEnabled
                }"
                (click)="toggled.emit()"
            >
                <div class="piToggle_toggleArea togglerWithWarning">
                    <div class="piToggle_toggleArea_ball"></div>
                </div>
                <div class="piToggle_label togglerWithWarning">
                    {{ togglerWithWarningObject.togglerText }}
                </div>
            </div>
            @if (togglerWithWarningObject.showWarning) {
                <warning-tooltip
                    [warningTextsObject]="warningTexts"
                    (clickedProceed)="clickedProceed.emit()"
                    (clickedCancel)="clickedCancel.emit()"
                ></warning-tooltip>
            }
        </div>
    `,
    standalone: false
})
export class TogglerWithWarningComponent implements OnInit {
    @Input()
    togglerWithWarningObject: togglerWithWarningObject;
    @Output()
    toggled = new EventEmitter<void>();
    @Output()
    clickedProceed = new EventEmitter<void>();
    @Output()
    clickedCancel = new EventEmitter<void>();

    warningTexts: warningTextsObject;

    ngOnInit() {
        this.warningTexts = {
            warningText: this.togglerWithWarningObject.togglerWarningText,
            leftButtonText: this.togglerWithWarningObject.leftButtonText,
            rightButtonText: this.togglerWithWarningObject.rightButtonText
        };
    }

    focusLost() {
        this.togglerWithWarningObject.showWarning = false;
    }
}
